import { DagResponse, DagFetchMode } from '../types/dag';

/**
 * Fetch the DAG for a session.
 *
 * Per Trailmap spec §7.2 + L1 plan Task 11.
 *
 * RE-THROWS on error per feedback_silent_swallow_returning_defaults —
 * empty defaults are indistinguishable from legitimate empty responses,
 * which has bitten Alan's chat surface before. UI callers handle the
 * throw via react-query / hook error boundaries; never swallow into [].
 */
export async function fetchDag(
  sessionId: string,
  mode: DagFetchMode = 'skeleton',
): Promise<DagResponse> {
  const url = `/api/chat/sessions/${encodeURIComponent(sessionId)}/dag?fields=${mode}`;
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    throw new Error(
      `fetchDag(${sessionId}, ${mode}) failed: ${response.status} ${response.statusText}`,
    );
  }
  return (await response.json()) as DagResponse;
}
